import React, { Component } from "react";

import {
  getPriceGrid,
  reorderPriceGrid,
  deletePrice,
  setDefaultPrice
} from "../../services/api";

import List from "../../components-utils/List";

export default class Grid extends Component {
  render() {
    return (
      <List
        getItems={getPriceGrid}
        reorderItem={reorderPriceGrid}
        deleteItem={deletePrice}
        setDefaultItem={setDefaultPrice}
        path="/price-grid"
        elementName="prix"
        elementGender="m"
        hasDefault
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grid/Grid.js